import {
    Edit,
    DateInput,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput,
    AutocompleteInput,
} from '@/components/admin';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle2 } from 'lucide-react';

export const ServiceTicketEdit = () => (
    <Edit title="Edit Service Ticket" mutationMode="pessimistic" redirect="show" className="p-6">
        <SimpleForm className="max-w-4xl mx-auto">

            <div className="space-y-6 w-full">
                <Card>
                    <CardHeader className="pb-3 border-b">
                        <CardTitle className="text-xs font-bold uppercase tracking-widest text-slate-500">Core Information</CardTitle>
                    </CardHeader>
                    <CardContent className="pt-6 space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <TextInput source="title" label="Ticket Title" isRequired />
                            <SelectInput
                                source="category"
                                label="Category"
                                choices={[
                                    { id: 'maintenance',  name: '🔧 Maintenance' },
                                    { id: 'installation', name: '🏗️ Installation' },
                                    { id: 'repair',       name: '🛠️ Repair' },
                                    { id: 'inspection',   name: '🔍 Inspection' },
                                ]}
                            />
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <SelectInput
                                source="priority"
                                label="Priority"
                                isRequired
                                choices={[
                                    { id: 'low',      name: '⚪ Low' },
                                    { id: 'medium',   name: '🔵 Medium' },
                                    { id: 'high',     name: '🟡 High' },
                                    { id: 'critical', name: '🔴 Critical' },
                                ]}
                            />
                            <SelectInput
                                source="status"
                                label="Status"
                                isRequired
                                choices={[
                                    { id: 'open',        name: 'Open' },
                                    { id: 'in_progress', name: 'In Progress' },
                                    { id: 'resolved',    name: 'Resolved' },
                                    { id: 'closed',      name: 'Closed' },
                                ]}
                            />
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader className="pb-3 border-b">
                        <CardTitle className="text-xs font-bold uppercase tracking-widest text-slate-500">Assignments & Links</CardTitle>
                    </CardHeader>
                    <CardContent className="pt-6 space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <ReferenceInput source="company_id" reference="companies">
                                <SelectInput label="Customer / Company" optionText="name" className="w-full" />
                            </ReferenceInput>
                            <ReferenceInput source="project_id" reference="projects">
                                <SelectInput label="Linked Project" optionText="name" className="w-full" />
                            </ReferenceInput>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <ReferenceInput source="assigned_to" reference="sales">
                                <AutocompleteInput 
                                    label="Assigned To" 
                                    optionText={(record: any) => record ? `${record.first_name} ${record.last_name}` : ''}
                                    className="w-full"
                                />
                            </ReferenceInput>
                            <DateInput source="due_date" label="Due Date" />
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader className="pb-3 border-b">
                        <CardTitle className="text-xs font-bold uppercase tracking-widest text-slate-500">Description & Resolution</CardTitle>
                    </CardHeader>
                    <CardContent className="pt-6 space-y-4">
                        <TextInput source="description" label="Description" multiline rows={4} />
                        <div className="flex items-center gap-2 pt-2 border-t mt-4 mb-2">
                            <CheckCircle2 className="w-4 h-4 text-emerald-500" />
                            <span className="text-xs font-bold uppercase tracking-widest text-emerald-700">Resolution Status</span>
                        </div>
                        <TextInput source="resolution_notes" label="Resolution Notes" multiline rows={4} helperText="Describe how the ticket was resolved" />
                        <DateInput source="resolved_date" label="Resolved Date" />
                    </CardContent>
                </Card>
            </div>
        </SimpleForm>
    </Edit>
);
